import useResponseToPDF from '@app/src/components/ExportToPDF/useResponseToPDF'
import SectionSkeleton from '@app/src/components/Skeleton/Section'
import ReportHeader from '@app/src/pages/Questionnaire/Provider/Report/ReportHeader'
import { useReport } from '@app/src/pages/Questionnaire/ReportContext'
import ReportingDescription from '@app/src/pages/Questionnaire/ReportingDescription'
import { HistoryStatus } from '@app/src/types/resourceExplorer'
import { Box, Divider, Stack, Typography } from '@mui/material'
import React, { useRef } from 'react'
import SubmitButton from '../Actions/SubmitButton'
import { useProviderReport } from '../ProviderReportContext'
import Section from './Section'

const Report: React.FC = () => {
  const { request, isRequestLoading, isPreview, response, reportStatus } = useReport()
  const { isPreparingDraft } = useProviderReport()
  const contentRef = useRef<HTMLDivElement>(null)
  const { generatePDF, isLoading: isPdfLoading } = useResponseToPDF(
    contentRef,
    request?.title,
    request?.targetAliasObject?.name,
    request?.periodName,
    response?.submittedAt,
  )

  const isLoading = isRequestLoading || isPreparingDraft
  const sections = request?.sections

  return (
    <Box
      ref={contentRef}
      bgcolor={
        reportStatus === HistoryStatus.Submitted || reportStatus === HistoryStatus.Approved
          ? 'grey.200'
          : 'common.white'
      }
      py={3}
      px={5}
      borderRadius={2}
    >
      {!isPreview && (
        <Box data-pdf-hide>
          <ReportHeader generatePDF={generatePDF} isPdfLoading={isPdfLoading} isRequestLoading={isRequestLoading} />
          <Divider sx={{ mb: 3 }} />
        </Box>
      )}

      <Box mb={5}>
        {isPreview && (
          <Typography variant="h1" gutterBottom>
            {request?.title}
          </Typography>
        )}
        <ReportingDescription />
      </Box>

      {isLoading ? (
        <SectionSkeleton howMany={2} />
      ) : (
        sections?.map((section, index) => (
          <Section key={section?.id ?? index} section={section} sectionNumber={index + 1} />
        ))
      )}
      {!isLoading && reportStatus === HistoryStatus.Draft && (
        <Stack data-pdf-hide direction="row-reverse" pt={4}>
          <SubmitButton />
        </Stack>
      )}
    </Box>
  )
}

export default Report
